import Content from '../types/enums/content';
import RegularEvent from './regularEvent';
import { IAppEventRequest } from '../types/interfaces/event';

class AppEvent extends RegularEvent {
  remoteApp: string;
  constructor(request: IAppEventRequest) {
    super(request, Content.APP);
    this.remoteApp = request.appName;
  }
}

export default AppEvent;
